<script setup lang="ts">
import type { ProductWithDetails } from '../../types';
import Modal from '../Modal.vue';
import LaboratoryDetailsTable from './LaboratoryDetailsTable.vue';

const props = defineProps<{
  show: boolean;
  product: ProductWithDetails | null;
  originalProduct: ProductWithDetails | null;
}>();

const emit = defineEmits(['close']);
</script>

<template>
  <Modal
    :show="show"
    :title="product?.Nombre || ''"
    @close="emit('close')"
  >
    <div class="space-y-4">
      <LaboratoryDetailsTable
        v-if="originalProduct"
        :product="originalProduct"
      />
    </div>
  </Modal>
</template>